module.exports = __webpack_public_path__ + "static/media/started-pattern-three.314102cc.png";